import type { ArticleV2 as ArticleV2Type } from 'types/capi/article';

import ArticleV2 from '~/components/article/ArticleV2';
import seo from '~/utils/seo';

export default function FeaturesRoute() {
  return <ArticleV2 />;
}

type LoaderData = {
  pageData: ArticleV2Type;
};

export const meta = ({ data }: { data?: LoaderData }) => {
  return data
    ? seo.formatForMeta(data.pageData.canonical_url, data.pageData.seo)
    : [];
};

export { loader } from './loader.server';
